import loadable from '@loadable/component';
export const manifest = {
  Subscriber: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "Subscriber";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "Subscriber" */
          './src'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./src");
            }

            return eval('require.resolve')("./src");
          }

        }, {
          resolveComponent: m => m.Subscriber
        })
      }
    }
  }
};